var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"container header"},[(_vm.$route.path !== '/')?_c('router-link',{staticClass:"header__home-button",attrs:{"to":"/"}},[_vm._v("На главную")]):_vm._e(),_c('h1',[_vm._v("Книга контактов")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }